import { useEffect, useState } from "react";

import { FadeEffect } from "@/react/components/Paywalls/CheckoutWithSession/pages/OfferPage/components/FadeEffect";
import { classNames } from "@/react/helpers/twMergeWithCN";
import { useIsCircleV4FeatureEnabled } from "@/react/hooks/useIsCircleV4FeatureEnabled";

import { DefaultFullPreview } from "../DefaultFullPreview";
import { DEFAULT_FULL_PREVIEW_VARIANT } from "../DefaultFullPreview/constants";
import { usePricePreviewContext } from "../PricePreviewProvider";
import { DiscountLine } from "./Lines/DiscountLine";
import { TotalDueLine } from "./Lines/TotalDueLine";
import { ViewOrderDetailsCollapseLine } from "./Lines/ViewOrderDetailsCollapseLine";

export const OfferPagePreview = () => {
  const { previewMutation } = usePricePreviewContext();
  const [shouldShowPreview, setShouldShowPreview] = useState(false);
  const isV4Modal = useIsCircleV4FeatureEnabled("circle_v4_modals_enabled");

  useEffect(() => {
    if (!previewMutation.data) {
      setShouldShowPreview(false);
    }
  }, [previewMutation?.data]);

  return (
    <div
      className={classNames("flex flex-col gap-y-4", {
        "border-b border-primary": shouldShowPreview && !isV4Modal,
      })}
    >
      <div className="flex flex-col gap-y-0.5">
        <div className="flex flex-row justify-between">
          <TotalDueLine />
        </div>
        <div className="flex flex-row justify-between">
          <ViewOrderDetailsCollapseLine
            toggle={() => setShouldShowPreview(!shouldShowPreview)}
            isLoading={previewMutation.isPending}
            value={shouldShowPreview}
          />
          <DiscountLine />
        </div>
      </div>
      <FadeEffect shouldShow={shouldShowPreview}>
        {previewMutation.data && (
          <div className="flex flex-col">
            <DefaultFullPreview.FirstPaymentPreview
              preview={previewMutation.data}
              className="pb-4"
              variant={DEFAULT_FULL_PREVIEW_VARIANT.paywall_customization}
            />
            <DefaultFullPreview.PaymentAfterTrialPreview
              preview={previewMutation.data}
              className="py-4"
              variant={DEFAULT_FULL_PREVIEW_VARIANT.paywall_customization}
            />
            <DefaultFullPreview.FuturePaymentsPreview
              preview={previewMutation.data}
              className="py-4"
              variant={DEFAULT_FULL_PREVIEW_VARIANT.paywall_customization}
            />
            <DefaultFullPreview.RemainingPaymentsPreview
              preview={previewMutation.data}
              className="py-4"
              variant={DEFAULT_FULL_PREVIEW_VARIANT.paywall_customization}
            />
            <DefaultFullPreview.PaymentSchedulePreview
              preview={previewMutation.data}
              className="py-4"
              variant={DEFAULT_FULL_PREVIEW_VARIANT.paywall_customization}
            />
          </div>
        )}
      </FadeEffect>
    </div>
  );
};
